// Get all matching .iww-news-filter__item elements
const items = document.querySelectorAll('.iww-news-filter__item');

// Iterate over the NodeList of elements to add the click event listener
items.forEach(item => {
    item.addEventListener('click', function(event) {
        // Check if the clicked element has the 'iww-news-filter__item--more' class
        if (!this.classList.contains('iww-news-filter__item--more')) {
            // Get all matching .iww-news-filter__item--active elements that are not the clicked element
            const activeItems = document.querySelectorAll('.iww-news-filter__item--active')
                .filter(item => item !== this);

            // Get all matching .iww-news-filter__item--active elements that are not the clicked element
            const activeItemsNotThis = document.querySelectorAll('.iww-news-filter__item--active')
                .filter(item => item !== this);

            // Hide the matched elements
            activeItems.forEach(activeItem => {
                activeItem.style.display = 'none';
            });

            // Toggle the 'iww-news-filter__item--active' class on the clicked element
            this.classList.toggle('iww-news-filter__item--active');

            // Check if the clicked element has the 'iww-news-filter__item__subfilter__item' class
            if (!event.target.classList.contains('iww-news-filter__item__subfilter__item')) {
                // Get the next element with the 'iww-news-filter__subfilter' class and toggle its display
                const subfilter = this.nextElementSibling
                    .filter(sub => sub.classList.contains('iww-news-filter__subfilter'));
                subfilter.style.display = subfilter.style.display === 'none' ? 'block' : 'none';
            }
        }
    });
});


const hamburger = document.querySelector('.iww-hamburger--newslist');
const newsFilter = document.querySelector('.iww-mobile-news-filter');

if (hamburger && newsFilter) {
    hamburger.addEventListener('click', function () {
        this.classList.toggle('iww-is-active');
        const height = newsFilter.clientHeight;
        if (newsFilter.style.display === 'none') {
            newsFilter.style.display = 'block';
            newsFilter.animate([
                {transform: `translateY(-${height}px)`},
                {transform: 'translateY(0px)'}
            ], {
                duration: 500,
                easing: 'ease-out'
            });
        } else {
            newsFilter.animate([
                {transform: 'translateY(0px)'},
                {transform: `translateY(-${height}px)`}
            ], {
                duration: 500,
                easing: 'ease-out'
            }).onfinish = function () {
                newsFilter.style.display = 'none';
            };
        }
    });
}
